import {Component, Input, OnInit} from '@angular/core';
import {OrderService} from "../../../../../../core/services/OrderService";
import {ModelToolsProvider} from "../../../../../../framework/providers/model-tools/model-tools";
import {ItemProvider} from "../../../../../../core/pages/item/providers/item-provider/item-provider.service";
import {CatalogAdminService} from "../../../../services/catalogAdminService";
import {PopoverController} from "@ionic/angular";
import {Events} from "../../../../../../framework/providers/events";

@Component({
    selector: 'app-catalog-menu',
    templateUrl: './catalog-menu.component.html',
    styleUrls: ['./catalog-menu.component.scss'],
})
export class CatalogMenuComponent implements OnInit {

    @Input()
    model: any;
    @Input()
    isItem: boolean = false;

    constructor(public orderService: OrderService,
                public events:Events,
                public tools: ModelToolsProvider,
                public popoverController:PopoverController,
                public itemProvider: ItemProvider,
                public catalogAdminService: CatalogAdminService) {
    }

    ngOnInit() {
        console.log('model:')
        console.log(this.model);
    }

    initObject(model = null) {
        return {
            'model': model,
            'models': [],
            'checked': null,
            'checkedData': {
                'sections': true
            }
        }
    }

    openItem() {
        // let autoProps = this.model.data.autoProps;
        // this.itemProvider.openItem(this.model, this.cartModel, autoProps, {
        //     'listIndex': this.listIndex,
        //     'listPrefix': this.listPrefix
        // });
        // this.cartModel.data['visible'] = true;
    }

    close() {
        this.popoverController.dismiss();
    }

    refresh()
    {
        this.events.publish('refresh_section_'+this.model.data.id);
    }
}
